<template>
  <div class="header collapse d-lg-flex p-0" id="headerMenuCollapse">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg order-lg-first">
          <ul class="nav nav-tabs border-0 flex-column flex-lg-row">
            <li class="nav-item" >
              <router-link :to="{name:'Horaires'}" :class="{ 'active': isActive('Horaires') }" class="nav-link"> 
                <i class="fe fe-calendar"></i> Horaires des collectes
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{name:'TypesCollectes'}" active-class="active" class="nav-link"> 
                <i class="fe fe-truck"></i> Types de collectes
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{name:'Ecocentres'}" active-class="active" class="nav-link"> 
                <i class="fe fe-disc"></i> Écocentres
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link :to="{name:'Recherche'}" active-class="active" class="nav-link"> 
                <i class="fe fe-search"></i> Recherche
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState([

      ])
    },
    data() {
      return {

      }
    },
    created () {
      var self = this;
    },
    methods: {
      isActive(route) {
        return this.$route.name.startsWith(route);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// NavBar.vue?562b6644